import {
  createKizenProxyError,
  handleKizenNetworkResponse,
  KizenRequestError,
} from '@kizenapps/engine/util';
import { isAxiosError } from 'axios';
import AxiosService from 'services/AxiosService';

export const handleAxiosResponseForPluginCall = async (
  method: 'get' | 'post' | 'put' | 'patch' | 'delete',
  url: string,
  payload?: any,
  options?: any
) => {
  const isProxyRequest = url.startsWith('/external-integrations/proxy');

  // Proxy requests get special error handling
  if (isProxyRequest) {
    try {
      const response = await AxiosService[method](url, payload, options);

      const processedResponse = handleKizenNetworkResponse(response);

      return processedResponse;
    } catch (ex) {
      // Re-throw KizenRequestErrors, they will be handled correctly
      if (ex instanceof KizenRequestError) {
        throw ex;
      }

      // If we get an Axios error at this point, is means we failed to call the proxy
      if (isAxiosError(ex)) {
        throw createKizenProxyError(
          ex.response?.status,
          ex.response?.data?.error
        );
      }

      // This would be unexpected, but we should re-throw in case something falls through
      throw ex;
    }

    // Non-proxy requests are handled as normal
  } else {
    const result = await AxiosService[method](url, payload, options);

    return result;
  }
};
